
import React from "react";
import AdminLayout from "@/components/admin/AdminLayout";
import InsightResourcesManager from "@/components/admin/insights/InsightResourcesManager";

const InsightResourcesPage: React.FC = () => {
  return (
    <AdminLayout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold mb-8">Insight Resources Management</h1>
        <InsightResourcesManager />
      </div>
    </AdminLayout>
  );
};

export default InsightResourcesPage;
